import React from 'react'
import TrackChart from './track-chart'
import StyleControls from './style-controls'
import { metersToDisplayDistance, distanceUnit } from '../../../../../lib/trackStats'
import { FREE_COLOR } from '../../../../../lib/trackColor'

const ROLL_DASH = { solid: 'none', dots: '0.1 20', dashed: '22 14' }

const ProBadge = () => <span className="td-pro-badge">PRO</span>

const TrackEdit = (props) => {
  const {
    name, notes, units, isPro, stats, allPoints, nPts,
    color, lineStyle, lineWidth, trim, trimmed, colors, lineStyles, widths,
    styleOpen, onToggleStyle, onName, onNotes, onColor, onLineStyle, onWidth,
    onTrimChange, onTrimCommit, onResetTrim, onHover, onClose, onCancel, onSave
  } = props

  const dU = distanceUnit(units)
  const fullTotal = allPoints.length ? metersToDisplayDistance(allPoints[allPoints.length - 1].distM, units) : 0
  const kept = metersToDisplayDistance(stats.distanceM || 0, units)
  const ptsRemoved = nPts - (trim[1] - trim[0] + 1)
  const xLabels = [0, 0.25, 0.5, 0.75, 1].map(f => (fullTotal * f).toFixed(1))

  return (
    <div className="td-panel">
      <div className="td-header">
        <span className="td-header-title">EDIT TRACK</span>
        <span className="td-close" onClick={onClose}>×</span>
      </div>

      <div className="td-body">
      <div className="td-name-row">
        <label className="td-stat-label td-name-label">Name</label>
        <input className="td-input" value={name} onChange={e => onName(e.target.value)} />
      </div>

      {/* Style rollup */}
      <div className="td-rollup">
        <div className="td-rollup-header" onClick={onToggleStyle}>
          <div className="td-rollup-title">
            Style {!isPro && <ProBadge />}
          </div>
          <div className="td-rollup-right">
            <svg width="64" height="9" style={{ marginRight: 10 }}>
              <line x1="2" y1="4.5" x2="62" y2="4.5" stroke={color} strokeWidth="3" strokeLinecap="round"
                pathLength="100" strokeDasharray={ROLL_DASH[lineStyle]} />
            </svg>
            <svg className="td-chevron" width="16" height="16" viewBox="0 0 24 24"
              style={{ transform: styleOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <path d="M6 9l6 6 6-6" fill="none" stroke="#959595" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
        {styleOpen && (
          <div className="td-rollup-body">
            <StyleControls
              colors={colors} color={color} onColor={onColor}
              lineStyles={lineStyles} lineStyle={lineStyle} onLineStyle={onLineStyle}
              widths={widths} lineWidth={lineWidth} onWidth={onWidth}
              isPro={isPro} freeColor={FREE_COLOR}
            />
          </div>
        )}
      </div>

      {/* Trim Track */}
      <div className="td-trim">
        <div className="td-trim-header">
          <span className="td-trim-title">TRIM TRACK {!isPro && <ProBadge />}</span>
          {trimmed && <span className="td-reset-trim" onClick={onResetTrim}>RESET TRIM</span>}
        </div>
        <TrackChart
          points={allPoints} units={units} mode="trim" color={color} height={120}
          trim={trim} onTrimChange={onTrimChange} onTrimCommit={onTrimCommit} onHover={onHover}
        />
        <div className="td-trim-xaxis">
          {xLabels.map((x, i) => <span key={i}>{x}</span>)}
        </div>
        <div className="td-trim-kept">
          Kept {kept.toFixed(2)} of {fullTotal.toFixed(2)} {dU}
          <span style={{ color: '#c1c0c0' }}> · {ptsRemoved} pts removed</span>
        </div>
      </div>

      <textarea
        className="td-notes"
        placeholder="Add notes about this track…"
        value={notes}
        onChange={e => onNotes(e.target.value)}
      />
      </div>

      <div className="td-footer">
        <button className="td-btn td-btn-grey" onClick={onCancel}>CANCEL</button>
        <button className="td-btn td-btn-green td-btn-primary" onClick={onSave}>SAVE</button>
      </div>
    </div>
  )
}

export default TrackEdit
